import {
  FETCH_ALERTS_BEGIN,
  FETCH_ALERTS_SUCCESS,
  FETCH_ALERTS_FAILURE,
  FETCH_ALERTS_DISMISS_ERROR,
} from './constants';
import { serviceFind } from '../../../common/feathers'

export const fetchAlerts = serviceFind('alerts', {
  begin: FETCH_ALERTS_BEGIN,
  success: FETCH_ALERTS_SUCCESS,
  fail: FETCH_ALERTS_FAILURE
})

export function dismissFetchAlertsError() {
  return {
    type: FETCH_ALERTS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case FETCH_ALERTS_BEGIN:
      return {
        ...state,
        fetchAlertsPending: true,
        fetchAlertsError: null,
        alerts: []
      };

    case FETCH_ALERTS_SUCCESS:
      return {
        ...state,
        fetchAlertsPending: false,
        fetchAlertsError: null,
        alerts: action.data
      };

    case FETCH_ALERTS_FAILURE:
      return {
        ...state,
        fetchAlertsPending: false,
        fetchAlertsError: action.data.error,
      };

    case FETCH_ALERTS_DISMISS_ERROR:
      return {
        ...state,
        fetchAlertsError: null,
      };

    default:
      return state;
  }
}
